<div id="wrapper" class="h-100vh p-3">
  <!-- Content Wrapper -->
  <div id="content-wrapper" class="d-flex flex-column ml-0">
    <!-- Main Content -->
    <div id="content">
      <div class="container-fluid">
        <div class="row logo">
          <div class="col-12 row no-gutters justify-content-center">
            <h1
              class="d-flex justify-content-center"
              style="flex-direction: column; align-items: center"
            >
              <img src="/assets/doctors-next/Logo.png" alt="Doctors Next" />
            </h1>
          </div>
        </div>
        <div class="text-center">
          <h1 class="h3">COLLABO Portalと連携</h1>
        </div>

        <div class="bgBox">
          <img
            src="/assets/doctors-next/logo-connect.svg"
            width="268"
            height="16"
            alt="DoctorsNext®⇔COLLABO Portal"
          />
          <div class="address">
            {{ email }}
          </div>
          <p>
            ご入力のメールアドレスは Doctors Next の提携サービス 「COLLABO
            Portal」で既に登録されています。ご登録情報を連携することにより、ご本人確認などの登録手続きを省略することができます。
          </p>
          <p class="buttonWrapper-link">
            <a
              href="https://collaboportal.com/"
              target="_blank"
              rel="noopener noreferrer"
              class="text-link"
              >COLLABO Portalとは</a
            >
          </p>
        </div>

        <div class="scrollBox">
          <section>
            <h2 class="title">外部サービスアカウント連携利用規約</h2>
            <h3 class="sub-title">第1条 利用規約の目的および適用</h3>
            <p>
              1.
              外部サービスアカウント連携利用規約（以下「本規約」といいます）は、株式会社コラボスクエア（以下「当社」といいます）がCOLLABO
              Portal（以下「本サービス」といいます）のサービスにおいて、他社が運営するサービス（以下「外部サービス」といいます）のアカウントを連携し、外部サービスを利用することに対して適用されるものです。外部サービスを利用する者は、本規約の内容を承認し、これに同意したものとみなされます。
            </p>
            <br />
            <h3 class="sub-title">
              第2条 外部サービスの利用及び連携の手続きについて
            </h3>
            <p>
              1.
              会員は、外部サービスのアカウント登録及び利用に際して、該当する外部サービスの運営者が定める利用規約に従うものとします。
            </p>
            <p>
              2.
              会員は､外部サービスとの連携時の注意事項および承諾事項はコラボポータル利用規約(<a
                href="https://dx.collaboportal.com/terms"
                target="_blank"
                rel="noopener noreferrer"
                class="text-link"
                >https://dx.collaboportal.com/terms</a
              >)の「第31条
              (外部サービスの利用)」､第32条（外部サービスとの連携）」に従うものとする｡
            </p>
            <p>
              3.
              会員が外部サービスにおけるアカウントの登録、管理等を行うにあたっては、全て自己の責任で行うものとし、管理不十分、使用上の過誤、第三者による使用等に起因するいかなる損害も、当社は責任を負わないものとします。
            </p>
            <p>
              4.
              外部サービスに連携を行う際に「ユーザー識別子」「メールアドレス」「姓名」「生年」「性別」「職種」「所属施設」を外部サービスに提供いたします。
            </p>
            <br />
            <h3 class="sub-title">第3条 外部サービス利用における責任</h3>
            <p>
              1.
              外部サービスのアカウント及びパスワードの不正使用や第三者の使用によって生じた会員または第三者への損害については、会員が全責任を負うものとします。また、このような事由により当社が損害を受けた場合、会員は当社に対して全ての損害を賠償するものとします。
            </p>
            <p>
              2.
              会員は、外部サービスを自己の責任において利用し、その利用により生じた損害やトラブルについて、当社は一切の責任を負わないものとします。
            </p>
            <br />
            <h3 class="sub-title">第4条 本規約の変更</h3>
            <p>
              1.
              本規約は予告なく内容を変更する場合があります。変更した内容は本ページへ掲示することにより、即時効力を生ずるものとします。
            </p>
            <br />
            <br />
            <h2 class="title">Doctors Next® 利用規約</h2>
            <h3 class="sub-title">第1条 はじめに</h3>
            <p>
              1.
              この利用規約（以下「本利用規約」といいます。）は、ドクターズ株式会社（以下「弊社」といいます。）が本サイト上で提供するサービスをユーザーが利用する際の一切の行為に適用されます。
            </p>
            <p>
              2.
              本利用規約は、本サービスの利用条件を定めるものです。ユーザーは、本利用規約に従い本サービスを利用しなければなりません。
            </p>
            <p>
              3.
              ユーザーは、本サービスを利用することにより、本利用規約の全ての記載内容について同意したものとみなされます
            </p>
            <br />
            <h3 class="sub-title">第2条 定義</h3>
            <p>
              ・本利用規約において使用する用語の意義は、次の各号に定めるとおりとします。
            </p>
            <p>
              1. 「本サイト」とは、弊社が運営するウェブサイト「Doctors
              Next®」（<a
                href="https://doctors-next.com"
                target="_blank"
                rel="noopener noreferrer"
                class="text-link"
                >https://doctors-next.com</a
              >）をいいます。
            </p>
            <p>
              2.
              「本サービス」とは、本サイト上で提供される全てのサービスをいいます。
            </p>
            <p>
              3.「ユーザー」とは、本サイトを利用するためにユーザーとして登録されている者をいいます。
            </p>
            <p>
              4. 「医療者ユーザー」とは，医療従事者であるユーザーをいいます。
            </p>
            <p>
              5. 「一般ユーザー」とは，医療従事者ではないユーザーをいいます。
            </p>
            <p>
              6.
              「登録メールアドレス」とは、本サービスの提供を受ける目的で、ユーザーが弊社に提供したメールアドレスに係る情報をいいます。
            </p>
            <p>
              7.
              「メッセージ等の情報」とは、医療及び介護等における治療や診療上のメッセージ、データ、コミュニケーション、プロフィール、画像、動画等、本サービスの利用において発信又は閲覧できる情報をいいます。
            </p>
            <p>
              8.
              「投稿」とは、ユーザーが本サイトに情報をアップロードする行為をいいます。
            </p>
            <br />
            <h3 class="sub-title">第3条 本利用規約の範囲</h3>
            <p>
              1.
              本サイトにおいて、本利用規約の他に、本サービスの利用条件等が規定される場合があり、この場合、当該利用条件等は本利用規約の一部を構成するものとします。
            </p>
            <p>
              2.
              本利用規約に規定される本サービスの利用条件等と前項の利用条件等との間に齟齬がある場合，前項の利用条件等が優先して適用されるものとします。
            </p>
            <br />
            <h3 class="sub-title">第4条 本利用規約の変更</h3>
            <p>
              1.
              弊社は、弊社の判断により，理由を問わず、本利用規約の内容をいつでも任意に変更することができるものとします。
            </p>
            <p>
              2.
              変更後の利用規約は、弊社が別途定める場合を除いて、本サイト上に表示した時点より効力を生じるものとします。
            </p>
            <p>
              3.
              ユーザーが、本利用規約の変更の効力が生じた後において本サービスを利用した場合、ユーザーは変更後の利用規約の内容全てに同意したものとみなされます。
            </p>
            <p>
              4.
              弊社は、本サービスの充実を図るため、適宜、ユーザーの事前又は事後の了承を得ることなく、本サービスの内容及び利用方法等を調整することができます。
            </p>
            <p>
              5.
              弊社は、前項に基づき、本サービスの内容及び利用方法等を調整した場合は、本サービス上の表示その他の方法により、ユーザーが当該調整を確認できるようにするための合理的措置を講じるものとします。
            </p>
            <br />
            <h3 class="sub-title">第5条 個人情報の取扱い</h3>
            <p>
              ・弊社は、別途定める「個人情報保護方針」に基づき、個人情報を適切に取り扱うものとします。
            </p>
            <br />
            <h3 class="sub-title">第6条 通信の秘密</h3>
            <p>
              1.
              弊社は、電気通信事業法（昭和59年法律第86号）第4条に基づき、ユーザーの通信の秘密を守ります。
            </p>
            <p>
              2.
              弊社は、次の各号に掲げる場合には、当該各号に定める範囲内において前項の守秘義務を負わないものとします。
            </p>
            <ol>
              <li>
                1.
                刑事訴訟法（昭和23年法律第131号）又は犯罪捜査のための通信傍受に関する法律（平成11年法律第137号）の定めに基づく強制の処分又は裁判所の命令が行われた場合
                当該処分又は裁判所の命令の定める範囲内
              </li>
              <li>
                2. 法令に基づく強制的な処分が行われた場合
                当該処分又は命令の定める範囲内
              </li>
              <li>
                3.
                特定電気通信役務提供者の損害賠償責任の制限及び発信者情報の開示に関する法律（平成13年法律第137号）第4条に基づく開示請求の要件が充足されたと弊社が判断した場合
                当該開示請求の範囲内
              </li>
              <li>
                4.
                他人の生命、身体又は財産の保護のために必要があると弊社が判断した場合
                他人の生命、身体又は財産の保護のために必要な範囲内
              </li>
            </ol>
            <br />
            <h3 class="sub-title">第7条 サービスの変更等</h3>
            <p>
              ・弊社は、弊社の都合により、本サービスをいつでも任意の理由で追加、変更、中断、終了することができます。
            </p>
            <br />
            <h3 class="sub-title">第8条 ユーザーの登録情報の修正</h3>
            <p>
              1.
              ユーザーは，登録情報に変更があった場合，弊社の定める方法により当該変更内容を遅滞なく弊社に通知するものとします。
            </p>
            <p>
              2.
              弊社は、ユーザーの登録情報のうち誤記であることが明らかな部分及び本サービスを適切に提供するため修正する必要がある部分について、弊社の判断で修正を行う場合があります。その場合、弊社は、合理的な方法により、当該ユーザーに対して修正を行った旨及びその内容を通知するものとします。
            </p>
            <br />
            <h3 class="sub-title">第9条 入会</h3>
            <p>
              1.
              本サービスは、以下に該当する者のみが利用することができ，ユーザーでない者は利用することができません。
            </p>
            <ol>
              <li>① ユーザー（本条第２項及び第３項参照）</li>
              <li>
                ② 株式会社スズケンが提供するコラボポータルのユーザーのうち
                弊社所定の方法により本利用規約の内容に同意した者（以下
                「コラボポータルユーザー」といいます。）
              </li>
            </ol>
            <p>
              2.
              本サービスの利用を希望する者は、本利用規約の内容に同意した上で、弊社所定の方法により、入会の申込を行うものとします。
            </p>
            <p>
              3.
              入会の申込みをした者（以下「入会申込者」といいます。）は、弊社が入会の申込みを承諾した時点でユーザーになります。
            </p>
            <p>
              4.
              弊社は、弊社の定めるところにより，ユーザーの種別（医療者ユーザーか一般ユーザーか）及び利用環境等の条件に応じて、本サービスの機能やツールをユーザーに提供するものとします。
            </p>
            <p>
              5.
              弊社は、ユーザーに対して新サービスの告知、広告配信及びサービス運営上の事務連絡その他の情報提供を行います。
            </p>
            <br />
            <h3 class="sub-title">第10条 入会申込の不承諾</h3>
            <p>
              ・弊社は、次の各号のいずれかに該当する場合は、弊社の判断により、入会申込みを承諾しないことがあります。
            </p>
            <p>
              1.
              入会申込者が，弊社が指定する方法によらずに入会の申込みを行った場合
            </p>
            <p>2. 入会申込者が存在しないと弊社が判断した場合</p>
            <p>3. 入会申込者の申込みに、虚偽の内容が含まれている場合</p>
            <p>
              4.
              入会申込者の申込みに、有効なメールアドレスが記載されていない場合
            </p>
            <p>
              5.
              入会申込者が、過去に本サイトの利用資格の停止又は強制退会処分を受けた者である場合
            </p>
            <p>
              6.
              入会申込者が成年被後見人、被保佐人又は被補助人のいずれかであり、法定代理人、成年後見人、保佐人若しくは補助人の同意を得ていない場合
            </p>
            <p>7. その他弊社が不適切であると判断した場合</p>
            <br />
            <h3 class="sub-title">第11条 退会</h3>
            <p>
              ・ユーザーは、ユーザーが有する本サービスの利用資格の全てを失った時点で、本サービスから退会したものとみなされます。
            </p>
            <br />
            <h3 class="sub-title">第12条 利用資格の停止及び失効</h3>
            <p>
              1.
              ユーザーが退会を希望する場合には、ユーザーは、弊社所定の方法により、弊社に退会の申出を行うものとします。
            </p>
            <p>
              2.
              以下の各号の一に該当する場合、弊社は、事前に通知することなく、直ちに該当するユーザーの本サイト利用資格の全部若しくは一部を停止又は失効させることができるものとします。
            </p>
            <ol>
              <li>
                1.
                弊社が指定する方法によらずに入会の申込を行ったことが明らかとなった場合
              </li>
              <li>2. ユーザー資格を不正に利用した場合</li>
              <li>
                3. 弊社が承認した以外の方法で本サイトを営利目的に利用した場合
              </li>
              <li>4. ユーザーの登録情報に虚偽の内容が認められた場合</li>
              <li>
                5.
                本サイトの信用や社会的地位を脅かすおそれのあるユーザーの行為が発覚した場合
              </li>
              <li>6. ユーザーが本サイトやシステムを不正に利用した場合</li>
              <li>7. 本利用規約その他弊社が定める規約等に違反した場合</li>
              <li>8. ユーザーが死亡した場合</li>
              <li>
                9.
                その他、ユーザーによる本サイトの利用が不適切であると弊社が判断した場合
              </li>
            </ol>
            <p>
              3.
              ユーザーが本サービスの利用資格を失った場合、当該ユーザーは本サイトで保有する全ての情報および権利を失い、これによって生じた損失等について弊社は一切責任を負わないものとします。
            </p>
            <br />
            <h3 class="sub-title">
              第13条 登録メールアドレス及びパスワードの管理
            </h3>
            <p>
              1.
              ユーザーは、自分の管理に属する使用可能なメールアドレスを登録メールアドレスとして登録しなければならず、当該登録メールアドレスが自己の管理に属さなくなったときには、自己の管理に属する使用可能な別のメールアドレスに変更しなければならないものとします。
            </p>
            <p>
              2.
              ユーザーは、自己の登録メールアドレス及びパスワードの不正利用の防止に努めるとともに、その管理について一切の責任を負うものとします。
            </p>
            <p>
              3.
              登録メールアドレスやパスワードが第三者に利用されたことによって生じた迷惑及び損害については、弊社に故意又は重過失がある場合を除き、弊社はいかなる責任も負わないものとします。
            </p>
            <br />
            <h3 class="sub-title">第14条 アカウントの保有</h3>
            <p>
              1.
              ユーザーは1人につき1つのアカウントを保有するものとします。1人が複数のアカウントを保有すること、複数人が1つのアカウントを共同して保有することはできません。ただし、弊社が別途許可した場合を除きます。
            </p>
            <p>
              2.
              ユーザーはいかなる場合においても、アカウントを第三者に譲渡又は貸与することはできません。
            </p>
            <br />
            <h3 class="sub-title">第15条 利用環境の整備</h3>
            <p>
              1.
              ユーザーは、本サービスを利用するために必要なあらゆる機器、ソフトウェア、通信手段を自己の責任と費用において、適切に整備するものとします。
            </p>
            <p>
              2.
              ユーザーは自己の利用環境に応じて、コンピューター・ウィルスの感染の防止、不正アクセス及び情報漏洩の防止等のセキュリティ対策を講じるものとします。
            </p>
            <p>
              3.
              弊社はユーザーの利用環境について一切関与せず、一切の責任を負いません。
            </p>
            <br />
            <h3 class="sub-title">第16条 著作権等</h3>
            <p>
              1.
              ユーザーは，本サービスにおいて提供される情報の使用については，情報の内容及び使用方法を問わず、著作権法で定められる私的使用の範囲を権利者の許諾を得ることなく超えてはならないものとします。
            </p>
            <p>
              2.
              ユーザーは，本サービスにおいて提供される情報の第三者への提供及び公開については，情報の内容及び提供ないし公開の方法を問わず、権利者の許諾を得ることなく行ってはならないものとします。
            </p>
            <p>
              3.
              ユーザーは，上記の違反により問題が生じた場合は，弊社に迷惑及び損害を生じさせないよう、自己の費用と責任においてこれを解決しなければならないものとします。
            </p>
            <br />
            <h3 class="sub-title">第17条 料金及び支払方法</h3>
            <p>
              1.
              ユーザーは，本サービス利用の対価として，別途当社が定める利用料金を当社が指定する支払方法により当社に支払うものとします。
            </p>
            <p>
              2.
              ユーザーが利用料金の支払を遅滞した場合，ユーザーは年14.6％の割合による遅延損害金を弊社に支払うものとします。
            </p>
            <br />
            <h3 class="sub-title">第18条 禁止事項</h3>
            <p>
              ・ユーザーは、本サービスの利用にあたり、次に掲げる行為を行ってはならないものとします。ユーザーが禁止事項に違反した場合，弊社は、強制退会、利用停止、メッセージ等の情報の全部若しくは一部の削除、又は公開範囲の変更等の措置を採ることがあります。
            </p>
            <p>1. 本サイト上での治療や診断、施術などの医療行為</p>
            <p>2. 医療法、医師法、薬機法、その他の関連法案に抵触する行為</p>
            <p>
              3.
              医療情報を必要な範囲並びに許諾を得た範囲を越えて提供、公開する行為
            </p>
            <p>4. 緊急の症状に本サイトを通じて対応する行為</p>
            <p>5. 一般ユーザーが医療従事者になりすまして登録する行為</p>
            <p>6. 一般ユーザーを医療従事者になりすませる目的で招待する行為</p>
            <p>
              7.
              弊社もしくは他者の著作権、商標権等の知的財産権を侵害する行為、又は侵害するおそれのある行為
            </p>
            <p>
              8.
              弊社もしくは他者の財産、プライバシー若しくは肖像権を侵害する行為、又は侵害するおそれのある行為
            </p>
            <p>
              9.
              弊社もしくは他者を不当に差別若しくは誹謗中傷し、他者への不当な差別を助長し、又はその名誉若しくは信用を毀損する行為
            </p>
            <p>
              10.
              自分以外の人物を名乗ったり、代表権や代理権がないにもかかわらずあるものと装ったり、又は他の人物や組織と提携、協力関係にあると偽って本サービスを利用する行為
            </p>
            <p>
              11.
              詐欺、規制薬物の濫用、児童売買春、預貯金口座及び携帯電話の違法な売買等の犯罪に結びつく、又は結びつくおそれのある行為
            </p>
            <p>
              12.
              わいせつ、児童ポルノ又は児童虐待に相当するメッセージ等の情報（以下、本号において｢これらの情報｣といいます）について、次に掲げるいずれかの行為を行うこと
            </p>
            <ol>
              <li>1. これらの情報を投稿又は表示する行為</li>
              <li>2. これらの情報を収録した媒体を販売する行為</li>
              <li>
                3.
                これらの情報を収録した媒体の送信、表示、販売を想起させる広告を投稿又は表示する行為
              </li>
            </ol>
            <p>13. 性行為、わいせつな行為等を目的として利用する行為</p>
            <p>14. 面識のない異性との出会い等を目的として利用する行為</p>
            <p>15. 青少年の家出を誘引・助長する行為</p>
            <p>
              16.
              違法な賭博・ギャンブルを行わせ、又は違法な賭博・ギャンブルへの参加を勧誘する行為
            </p>
            <p>
              17.
              違法行為（けん銃等の譲渡、爆発物の製造、児童ポルノの提供、公文書偽造、殺人、脅迫等）を請け負い、仲介し、又は誘引する行為
            </p>
            <p>18. 他人を自殺に誘引又は勧誘する行為</p>
            <p>19. 次に掲げる内容の情報を、レビューに投稿する行為</p>
            <ol>
              <li>1. 医療関連施設を誹謗中傷する内容の情報</li>
              <li>2. 真否についての事実確認が困難な内容や虚偽の内容の情報</li>
              <li>
                3.
                衛生管理上の問題等のしかるべき公的機関へ届け出るべき事項に関する内容の情報
              </li>
              <li>4. その他弊社が不適切と判断する内容の情報</li>
            </ol>
            <p>
              20.
              他のユーザーに対して、無差別にメッセージを送信したり、全く面識のない人を無差別に本サービスに招待する行為
            </p>
            <p>
              21.
              ユーザー属性による機能やツールの制限を逸脱して本サービスを利用する行為（ただし、弊社が別に認めたものを除く。）
            </p>
            <p>
              22. 弊社の設備に蓄積された情報を不正に書き換え、又は消去する行為
            </p>
            <p>
              23.
              ウィルス等の有害なコンピュータプログラム等を送信又は掲載する行為
            </p>
            <p>
              24.
              弊社又は他者のサーバーに負担をかける行為，若しくは、本サービスの運営やネットワーク・システムに支障を与える行為、又はこれらのおそれのある行為
            </p>
            <p>
              25.
              法令、公序良俗又は本利用規約もしくはその他の利用規約等に違反し、又は他者の権利を侵害すると弊社が判断する行為
            </p>
            <p>26. その他、弊社が不適切であると判断する行為</p>
            <br />
            <h3 class="sub-title">第19条 ID及びパスワードの管理</h3>
            <p>
              1.
              ユーザーは、弊社がユーザーに付与するID及びパスワードによって本サービスを利用することができ、また、コラボポータルの利用規約に同意することにより、同一のID及びパスワードによりコラボポータルを利用することができます。
            </p>
            <p>
              2.
              弊社は、コラボポータルユーザーに対し、本サービスのID及びパスワードとして、コラボポータルにおけるID及びパスワードと同一のID及びパスワードを付与するものとし、コラボポータルユーザーは、同一のID及びパスワードにより、コラボポータルに加え、本サービスを利用することができます。
            </p>
            <p>
              3.
              弊社がユーザーに付与するID及びパスワードは、ユーザーが責任を持って管理するものとします。
            </p>
            <p>
              4.
              ユーザーは、ID及びパスワードについて，第三者に利用させること，第三者への譲渡及び貸与等をしてはならないものとします。
            </p>
            <p>
              5.
              ユーザーは、ID及びパスワードの使用及び管理等に関して生じた損害に係る責任を負うものとし、弊社は責任を負わないものとします。また、ID及びパスワードの利用は、全て、当該ID及びパスワードを保有しているユーザーによって行われたものとみなされ，第三者の利用によってユーザー又は第三者に損害が生じた場合であっても、弊社は責任を負わないものとします。
            </p>
            <p>
              6.
              ユーザーは、ID及びパスワードが、第三者に漏洩した場合及び第三者に使用されていることが判明した場合等には、その旨を弊社に報告して弊社の指示に従うものとします。
            </p>
            <p>
              7.
              ユーザーは、一定期間毎にパスワードを変更しなければならず、これを怠ったことによりユーザー又は第三者に生じた損害に係る責任を負うものとし、弊社は責任を負わないものとします。
            </p>
            <br />
            <h3 class="sub-title">第20条 サービスの利用条件</h3>
            <p>
              1. ユーザーは，本サービス の利用において，本サービス
              に関する弊社の所有権，著作権その他の権利（ロゴ，デザイン，テキスト，ソフトウェア，製図，構成，グラフィックス，ファイル，弊社の秘密情報等を含みますが，これらに限られません。）を一切取得しないものとする
            </p>
            <p>
              2.
              弊社が，ユーザーによる本サービスの利用にあたり，ユーザーが本サービス
              に入力したデータに関して，正当な知的財産権を有する第三者から当該データの削除を要請された場合，若しくは，当該データが法令に違反し又は第三者の権利を侵害している可能性がある旨の情報を受領した場合には，弊社は，速やかにその旨をユーザーに通知した上で，直ちに，当該データを削除するものとする。
            </p>
            <p>
              3.
              ユーザーは、本利用規約その他弊社が定める規約等又は随時通知する内容に従い、本サービスを利用するものとします。
            </p>
            <p>
              4.
              ユーザーは、本サービスを通じて発信する情報につき一切の責任を負うものとし、弊社に何らの迷惑及び損害を与えないものとします。
            </p>
            <p>
              5.
              本サービスの利用に関連して、ユーザーが他のユーザー若しくは第三者に対して損害を与えた場合、又はユーザーと他のユーザー若しくは第三者との間で紛争が生じた場合、当該ユーザーは自己の費用と責任で解決するものとし、弊社に何らの迷惑及び損害を与えないものとします。
            </p>
            <br />
            <h3 class="sub-title">第21条 サービスの停止</h3>
            <p>
              1.
              弊社は，以下各号いずれかの事由によって本サービスの提供が困難になった場合には，事前に通知することなく，本サービスの全部又は一部を停止することができる。
            </p>
            <ol>
              <li>1. 天災事変その他不測の事態の発生</li>
              <li>2. 通信回線の障害等の発生</li>
              <li>
                3.
                不正稼働，情報漏洩又はセキュリティ上の欠陥等の疑いがある場合であって，弊社が調査等を行うために直ちに本サービスを停止することが望ましいと判断した場合
              </li>
              <li>4. 上記1ないし3のおそれが生じた場合</li>
            </ol>
            <p>
              2.
              弊社は，定時に又は必要に応じて，保守作業のために，本サービスを一時的に停止することができる。なお，弊社は，保守作業を行う場合には，事前にユーザーに対してその旨を通知するものとする。ただし，緊急の場合には，事前の通知をすることなく本サービスを停止し，事後速やかにユーザーに通知するものとする。
            </p>
            <p>
              3.
              弊社は、本サービスの停止によってユーザーに損害が生じた場合であっても、責任を負わないものとします。
            </p>
            <br />
            <h3 class="sub-title">第22条 弊社の削除権限</h3>
            <p>
              ・弊社は、次に掲げる場合には、メッセージ等の情報の違法性・規約違反の有無に関わらず、関連するメッセージ等の情報について、その全部若しくは一部の削除又は公開範囲の変更等の不利益な措置を行うことができるものとします。
            </p>
            <ol>
              <li>
                1.
                人（実在の人物であるか否かを問わず、漫画・アニメ等のキャラクターを含みます。）の裸体（着衣の全部又は一部を欠くものをいいます。）を撮影・描写したメッセージ等の情報が投稿された場合
              </li>
              <li>
                2.
                公的な機関又は専門家（国、地方公共団体、特定電気通信役務提供者の損害賠償責任の制限及び発信者情報の開示に関する法律のガイドラインに規定された信頼性確認団体、インターネット・ホットラインセンター、弁護士等をいいます。）から、メッセージ等の情報について、違法、公序良俗違反又は他人の権利を侵害する等の指摘・意見表明があった場合
              </li>
              <li>
                3.
                権利者と称する者から、メッセージ等の情報が自分の権利を侵害する旨の申告があった場合（ただし、権利者と称する者から、権利者であることを合理的に判断できる資料を提示され、弊社にて慎重に検討した結果、権利者であると弊社が判断した場合に限る。）
              </li>
            </ol>
            <br />
            <h3 class="sub-title">第23条 関連企業に対する情報開示</h3>
            <p>
              ・弊社は、弊社と提携して弊社のサービスを利用する関連企業（医療機器メーカー、製薬メーカー及び医薬品卸等を含みますが，これらに限られません。）に対して，秘密保持義務を課した上で、当該企業が医療従事者に対するプロモーション及びマーケティングにおいて利用するために、ユーザーの情報（氏名、勤務先、医療資格及び診療科目、識別コード、指標化情報等）を開示することがあります。
            </p>
            <br />
            <h3 class="sub-title">第24条 ユーザーの責任</h3>
            <p>
              1.
              ユーザーは、ユーザー自身の自己責任において本サービスを利用するものとし、本サービスを利用してなされた一切の行為及びその結果について一切の責任を負います。
            </p>
            <p>
              2.
              ユーザーは、本サービスが医療や健康に関するものであることを十分認識し、自ら発信する情報はもとより、受信、閲覧、利用する情報について慎重に取り扱うものとします。
            </p>
            <p>
              3.
              ユーザーは本サイトにおいて治療や診断、施術その他の医療行為を行うことはできません。本サイトの医療情報の利用の結果生じたいかなる損失に対しても弊社は一切責任を負いません。
            </p>
            <p>
              4.
              医療者ユーザーは医師資格等の医療従事者資格をはじめとする自身の属性について虚偽の情報を掲載しないことを保証するものとします。
            </p>
            <p>
              5.
              一般ユーザーは自身の健康状態についてメッセージ等の情報を投稿する場合、正確性に配慮する義務があるものとします。
            </p>
            <p>
              6.
              一般ユーザーは本サイトの情報を利用する場合、自らの判断により利用するものとします。弊社はいかなる情報の利用についてもユーザーに対して強制するものではありません。
            </p>
            <p>
              7.
              本サービスを利用してユーザーが投稿したメッセージ等の情報に関する責任は、ユーザー自身にあります。弊社はユーザーが本サービスを利用して投稿したメッセージ等の情報の内容について、一切責任を負いません。
            </p>
            <p>
              8.
              ユーザーが他人の名誉を毀損した場合、プライバシー権を侵害した場合、許諾なく第三者の個人情報を開示した場合、著作権法（昭和45年法律第48号）に違反する行為を行った場合その他他人の権利を侵害した場合には、当該ユーザーは自身の責任と費用において解決しなければならず、弊社は一切の責任を負いません。
            </p>
            <p>
              9.
              ユーザーは他のユーザーを招待する場合、慎重を期すものとしユーザーの操作ミスや思い違いによって別人を招待した場合でも弊社は一切の責任を負いません。
            </p>
            <p>
              10.
              ユーザーは、ユーザーが本サービスを利用して投稿したメッセージ等の情報について弊社に保存義務がないことを認識し、ユーザーが必要とするメッセージ等の情報については自らの判断でバックアップをとるものとします。
            </p>
            <br />
            <h3 class="sub-title">第25条 メッセージ等の情報に関する権利</h3>
            <p>
              ・本サービスを利用してメッセージ等の情報を投稿するユーザーは、弊社に対し、当該メッセージ等の情報が第三者の権利を侵害していないことを保証するものとします。万一、第三者との間で何らかの紛争が発生した場合には、当該ユーザーの費用と責任において問題を解決するとともに、弊社に何らの迷惑及び損害を与えないものとします。
            </p>
            <br />
            <h3 class="sub-title">第26条 メッセージ等の情報の使用許諾等</h3>
            <p>
              1.
              本サービスを利用して投稿されたメッセージ等の情報の権利（著作権及び著作者人格権等の周辺権利）は、創作したユーザーに帰属します。
            </p>
            <p>
              2.
              弊社は、ユーザーが投稿するメッセージ等の情報を、本サービスの円滑な提供、弊社システムの構築、改良、メンテナンスに必要な範囲内で、使用することができるものとします。
            </p>
            <br />
            <h3 class="sub-title">第27条 免責事項</h3>
            <p>
              ・弊社は、本サービスに関連してユーザーが被った損害について，弊社に故意又は重過失による義務違反が認められる場合を除き，責任を負わないものとする。
            </p>
            <p>
              1.
              弊社は，ユーザーによる本サービスの利用又は本サービスのみなし利用若しくはユーザーによる本契約違反によってユーザーに生じた損害について，責任を負わないものとする。
            </p>
            <p>
              2.
              弊社は，第7条に基づいてなされた本サービスの変更によってユーザーに生じた損害について責任を負わないものとする。
            </p>
            <p>
              3.
              弊社は，第20条2項に基づいてなされたデータの削除によってユーザーに生じた損害について責任を負わないものとする。
            </p>
            <p>
              4.
              弊社は，ユーザーが自らの過失により発生したデータの滅失及び損壊によって生じた事業機会の損失，逸失利益については，契約責任，不法行為責任その他請求の原因を問わず，いかなる賠償責任も負わないものとする。
            </p>
            <p>
              5.
              本サービスに関連してユーザーと第三者との間で紛争が生じた場合，紛争当事者間で解決するものとし，ユーザーは弊社に対して損害賠償請求，苦情の申立て等をなし得ないものとする。
            </p>
            <p>
              6.
              弊社は，本サービスに掲載される記事その他の情報及び本サービス上で行われるチャット等の内容の真実性及び正確性等を保証するものではなく，これらが真実でなかった又は正確でなかったことによってユーザー又は第三者が損害を被った場合であっても，いかなる賠償責任も負わないものとする。
            </p>
            <p>
              7.
              弊社は，本サービスとリンクする他のウェブサイト及び当該サイトに掲載されている情報について，責任を負わないものとする。
            </p>
            <p>
              8.
              弊社は，本サービスが全ての端末に対応していることを保証するものではなく，非対応によってユーザーに生じた損害について責任を負わないものとする。
            </p>
            <p>
              9.
              弊社は，やむを得ない事由が生じた場合，本サービスを廃止することができ，これによってユーザーに生じた損害について責任を負わないものとする。
            </p>
            <p>
              10.
              弊社は，ユーザーが利用する情報が本サービスを提供する設備等の故障等により滅失した場合において，当該情報を復元する義務を負うものではなく，また，当該情報の滅失について責任を負わないものとする。
            </p>
            <p>
              11.
              弊社は，本サービスを適切に運営するために必要がある場合は，本サービス上で行われるチャット等の内容を閲覧したり，保存することができる。
            </p>
            <p>
              12.
              弊社は，法令又は裁判所，監督官庁，金融商品取引所その他弊社を規制する権限を有する公的機関の裁判，規則若しくは命令に従い必要な範囲において本サービス上で行われるチャット等の内容を当該機関に開示することができる。
            </p>
            <p>
              13.
              弊社は，ユーザーが利用する情報が本サービスを提供する設備等の故障等により滅失した場合において，当該情報を復元する義務を負うものではなく，また，本条第１項に該当しない限り，当該情報の滅失について責任を負わないものとする。
            </p>
            <br />
            <h3 class="sub-title">第28条 情報の管理及び利用</h3>
            <p>
              ・弊社は，本サービスの改良，サービスの維持管理等を目的とする統計調査のため，ユーザーの本サービスの利用状況，画面，項目の利用頻度等の統計数値を利用し，あるいは統計調査に必要な限度でこれらの情報を解析し，二次加工して利用するものとし，ユーザーはかかる統計調査，二次加工活用を行うことに同意する。
            </p>
            <p>
              1.
              弊社は，ユーザーが入力したデータに関し，善良なる管理者の注意義務をもって機密保持とその管理に努めるものとする。
            </p>
            <p>
              2.
              ユーザーは，弊社が，裁判所その他の法的な権限のある官公庁の命令等により本サービスに関する情報の開示ないし提出を求められた場合は，かかる命令等に従って情報の開示ないし提出をすることがあることを承諾し，かかる開示ないし提出に対して異議を述べないものとする。
            </p>
            <br />
            <h3 class="sub-title">第29条 契約上の地位の譲渡等</h3>
            <p>
              ・ユーザーは，弊社の文書による事前の承諾なく，本利用規約に係る契約上の地位又は本利用規約その他当社が定める規約等に基づく権利若しくは義務につき，第三者に対し，譲渡，移転，担保設定その他の処分をすることはできません。
            </p>
            <br />
            <h3 class="sub-title">
              第30条 本利用規約その他弊社が定める規約等の有効性
            </h3>
            <p>
              1.
              本利用規約その他弊社が定める規約等の規定の一部が法令に基づいて無効と判断されても、本利用規約その他弊社が定める規約等のその他の規定は有効とします。
            </p>
            <p>
              2.
              本利用規約その他弊社が定める規約等の規定の一部があるユーザーとの関係で無効とされ、又は取り消された場合でも，本利用規約その他弊社が定める規約等はその他のユーザーとの関係では有効とします。
            </p>
            <br />
            <h3 class="sub-title">
              第31条 本利用規約又はその他の利用規約等違反行為等への対処
            </h3>
            <p>
              ・本利用規約その他弊社が定める規約等に違反する行為を発見した場合には、お問い合わせフォームから通報して下さい。ただし、個別のサービスにおいて、特に、運営事務局に通報するためのリンクが設けられている場合には、当該リンク先から通報して下さい。
            </p>
            <p>
              ・ユーザーが本利用規約その他弊社が定める規約等に違反したと認められる場合、その他弊社が必要と認める場合は、弊社は当該ユーザーに対し以下の対処を講ずることがあります。
            </p>
            <ol>
              <li>
                1.
                本利用規約その他弊社が定める規約等に違反する行為等を止め、同様の行為を繰り返さないことを要求すること
              </li>
              <li>2. メッセージ等の情報の自発的削除・訂正を求めること</li>
              <li>
                3.
                メッセージ等の情報の全部若しくは一部を削除し、公開範囲を変更し、又は閲覧できない状態（非公開）にすること
              </li>
              <li>4. 強制退会処分とすること</li>
              <li>5. 入会申込者の入会申込を承諾しないこと</li>
            </ol>
            <p>
              ・ユーザーは、弊社が行った本利用規約その他弊社が定める規約等に違反する行為等への対処について、異議を申し立てることはできないものとします。
            </p>
            <br />
            <h3 class="sub-title">第32条 準拠法</h3>
            <p>・本利用規約の準拠法は日本法とします。</p>
            <br />
            <h3 class="sub-title">第33条 合意裁判管轄</h3>
            <p>
              1.
              本サービスに関連してユーザーと弊社との間で問題が生じた場合には，ユーザーと弊社で誠意をもって協議するものとします。
            </p>
            <p>
              2.
              本利用規約に起因し又は関連する一切の紛争については，東京地方裁判所を第一審の専属的合意管轄裁判所とします。
            </p>
            <br />
          </section>
        </div>

        <div class="actions">
          <button type="button" (click)="login()">
            利用規約に同意してログイン
          </button>
          <a class="text-link" (click)="gotoLoginPage()">キャンセル</a>
        </div>
      </div>
    </div>
  </div>
</div>
